/* eslint-disable prettier/prettier */
/* prettier-ignore-file */

import { apiService } from './api.service';

export interface Country {
	label: string;
	value: string; // ISO code
}

export const countryService = {
	async getAllCountries(): Promise<Country[]> {
		try {
			// ✅ apiService already unwraps response.data
			const response =
				await apiService.get<Country[]>('/country/countries');

			if (!response.success) {
				throw new Error(response.message);
			}

			return response.data;
		} catch (error: any) {
			console.error('Country fetch error:', error);
			throw new Error(error.message || 'Failed to fetch countries');
		}
	},
};
